<template>
  <public-reduced-layout :backVisible="false"></public-reduced-layout>
</template>

<script>
import PublicReducedLayout from '@/components/layouts/PublicReducedLayout'

export default {
  components: {
    PublicReducedLayout
  }
}
</script>

<style lang="scss">


</style>


// WEBPACK FOOTER //
// src/components/layouts/PublicReducedLayoutDynamic.vue